import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from "@mui/material";

import React, { useEffect, useRef, useState } from "react";
import { resendExpiredUserInvite } from "../services/signupService";

const ResetPasswordDialog = (props) => {
  const { onClose, open, registeredEmail } = props;
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [pwdResetErr, setPwdResetErr] = useState("");
  const [resultMessage, setResultMessage] = useState("");
  const closeTimerRef = useRef(null);

  useEffect(() => {
    return () => clearTimeout(closeTimerRef.current);
  }, []);

  const closeWithDelay = () => {
    clearTimeout(closeTimerRef.current);
    closeTimerRef.current = setTimeout(() => {
      restForm();
      onClose("success");
    }, 5000);
  };

  const handleResetPassword = () => {
    setIsFormSubmitted(true);
    setPwdResetErr("");
    resendExpiredUserInvite(registeredEmail)
      .then((res) => {
        setIsFormSubmitted(false);
        setResultMessage(
          res?.data?.message || "Password reset request completed successfully."
        );
        closeWithDelay();
      })
      .catch((err) => {
        setIsFormSubmitted(false);
        setPwdResetErr(err?.response?.data?.message || "An error occurred.");
      });
  };

  const handleClose = (event, reason) => {
    if (reason === "escapeKeyDown" || reason === "backdropClick") {
      return;
    }
    clearTimeout(closeTimerRef.current);
    onClose("closed");
    restForm();
  };

  const restForm = () => {
    setResultMessage("");
    setPwdResetErr("");
    setIsFormSubmitted(false);
  };

  const actionCompleted = !!resultMessage;

  return (
    <Dialog onClose={handleClose} open={open} fullWidth disableEscapeKeyDown>
      <DialogTitle>{actionCompleted ? "Info" : "Alert"}</DialogTitle>
      <DialogContent>
        <Box component="form" noValidate>
          <Grid
            container
            direction="column"
            justifyContent="center"
            alignItems="stretch"
          >
            <Grid item xs={12} sm={6} md={6}>
              <Typography
                component="div"
                variant="h6"
                sx={{ fontSize: "14px" }}
              >
                {resultMessage || "Do you want to reset the password?"}
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6} md={6}>
              <Typography
                variant="body2"
                sx={{ color: "#f44336", fontSize: "10px" }}
              >
                {pwdResetErr}
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button disabled={isFormSubmitted ? true : false} onClick={handleClose}>
          Close
        </Button>
        {!actionCompleted && (
          <Button
            onClick={handleResetPassword}
            disabled={isFormSubmitted ? true : false}
          >
            Reset Password
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default ResetPasswordDialog;
